import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrganisationDropdownComponent } from './organisation-dropdown.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule],
  declarations: [OrganisationDropdownComponent],
  exports: [OrganisationDropdownComponent],
})
export class OrganisationDropdownModule {}
